/**
 * Body classes per embed mode. Embedded pages (modal AND inline) render on a
 * transparent body: modal embeds sit on the host scrim; inline embeds must
 * sit directly on the host page background so the iframe blends in. Inline
 * additionally collapses the body height so auto-height reporting measures
 * content, not viewport.
 *
 * NOTE: inline transparency is shared with the giving inline embed. Success,
 * payment, and the auth layout paint getEmbedOpaqueSurfaceClass. The give
 * form and GivePageShell already paint the same fill on their own. Feeds
 * stay clear on purpose. The full-viewport height is embed-only so a normal
 * page does not grow past the navbar and footer.
 */
export const EMBED_OPAQUE_SURFACE_CLASS =
  "bg-system-screen dark:bg-system-screen-dark";

export function getEmbedOpaqueSurfaceClass(isEmbedded: boolean): string {
  return isEmbedded
    ? `${EMBED_OPAQUE_SURFACE_CLASS} min-h-screen`
    : EMBED_OPAQUE_SURFACE_CLASS;
}

export function getEmbedBodyClassName({
  isEmbedded,
  isInline,
}: {
  isEmbedded: boolean;
  isInline: boolean;
}): string {
  const background = isEmbedded
    ? "bg-transparent"
    : "bg-system-screen dark:bg-system-screen-dark";
  const height = isInline ? "min-h-0 h-auto" : "h-full";
  return `${background} ${height}`;
}
